query GetDigestPreview($digestType: DigestTypeEnum!) {
    digestPreview(digestType: $digestType) {
        previewHtml
    }
}
